import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PriceSuggestion } from 'src/app/models/product-hire-estimate';

export const HIREABLE_PRICE_UPDATE_IJ = new InjectionToken(
  'HireablePriceUpdate'
);

export interface HireablePriceUpdate {
  update(
    parentId: number,
    lineItemId: number,
    price: number,
    pricing_type: string,
    suggerstion?: PriceSuggestion,
    zeroPriceReason?: string,
    freeAccessory?: boolean
  ): Observable<void>;
}
